import {
  PLAN_CONTENT_ADD_NEW,
  PLAN_CONTENT_ADD_NEW_SUCCESS,
  PLAN_CONTENT_ADD_NEW_ERROR,
  PLAN_CONTENT_EDIT,
  PLAN_CONTENT_EDIT_SUCCESS,
  PLAN_CONTENT_EDIT_ERROR,
  PLAN_CONTENT_GET_BY_QUERY,
  PLAN_CONTENT_GET_BY_ID,
  PLAN_CONTENT_GET_BY_ID_SUCCESS,
  PLAN_CONTENT_GET_BY_ID_ERROR,
  PLAN_CONTENT_GET_BY_QUERY_SUCCESS,
  PLAN_CONTENT_GET_BY_QUERY_ERROR,
  PLAN_CONTENT_ADD_NEW_REQUEST,
  PLAN_CONTENT_DELETE,
  PLAN_CONTENT_DELETE_ERROR,
} from './types';
// item
const initialState = {
  item: null,
  items: [],
  loading: false,
  error: null,
  itemCount: 0,
  pageCount: 0,
  total: 0,
  addSuccess: false,
  editSuccess: false,
  deleteSuccess: false,
};

export default function initState(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case PLAN_CONTENT_ADD_NEW:
    case PLAN_CONTENT_DELETE:
    case PLAN_CONTENT_GET_BY_ID:
    case PLAN_CONTENT_GET_BY_QUERY:
      return {
        ...state,
        loading: true,
        error: null,
        deleteSuccess: true,
        addSuccess: true,
        editSuccess: false,
        item: null,
      };

    case PLAN_CONTENT_EDIT:
      return {
        ...state,
        loading: true,
        error: null,
        editSuccess: true,
      };
    case PLAN_CONTENT_EDIT_SUCCESS:
    case PLAN_CONTENT_ADD_NEW_REQUEST:
      return {
        ...state,
        loading: false,
        item: null,
        error: null,
      };
    case PLAN_CONTENT_ADD_NEW_SUCCESS:
    case PLAN_CONTENT_GET_BY_QUERY_SUCCESS:
      const { itemCount, pageCount, total, data } = payload;
      return {
        ...state,
        loading: false,
        items: data,
        total,
        itemCount,
        pageCount,
      };

    case PLAN_CONTENT_GET_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        item: payload,
      };

    case PLAN_CONTENT_ADD_NEW_ERROR:
    case PLAN_CONTENT_DELETE_ERROR:
    case PLAN_CONTENT_EDIT_ERROR:
    case PLAN_CONTENT_GET_BY_ID_ERROR:
    case PLAN_CONTENT_GET_BY_QUERY_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    default:
      return { ...state };
  }
}
